import { QueryClient } from '@tanstack/react-query'
import {
  HeadContent,
  Outlet,
  createRootRouteWithContext,
} from '@tanstack/react-router'
import * as v from 'valibot'

import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

const RootSearchParamsSchema = v.object({
  lang: v.optional(v.string()),
  cmi5_session_id: v.optional(v.pipe(v.string(), v.uuid())),
})

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  beforeLoad: ({ search }) => {
    if (search.cmi5_session_id) {
      sessionStorage.setItem('cmi5_session_id', search.cmi5_session_id)
    }
  },
  head: () => ({ meta: [{ title: buildPageTitle() }] }),
  validateSearch: RootSearchParamsSchema,
  component: Root,
})

function Root() {
  return (
    <>
      <HeadContent />
      <Outlet />
    </>
  )
}
